module.exports = __webpack_public_path__ + "static/media/logo.e5409038.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 31
// module chunks = 0